import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';

import {OptionService} from '../../services/option/option.service';
import {WordDispComponent} from './word-disp.component';
import {Router} from "@angular/router";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";


@Component({
  selector: 'app-dialect-disp',
  template: `
    <article class="keyword2">
      <table>
        <tbody>
        <tr class="sub top">
          <td *ngFor="let cs of word.wordStruct"
              class="{{ GetSeungjoClass(cs) }}">{{ GetSaseungTxt(cs) }}</td>
        </tr>
        <tr class="main">
          <td *ngFor="let cs of word.wordStruct; let idx = index"
              class="{{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}">{{ GetCharTxt(cs) }}</td>
          <td *ngIf="word.idxHomonym > 0"
              class="idx-homonym">{{ word.idxHomonym }}</td>
        </tr>
        <!-- tr class="sub bottom">
          <td *ngFor="let cs of word.wordStruct"
              class="{{ GetSeungjoClass2(cs) }}"></td>
        </tr -->
        </tbody>
      </table>

    </article>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialectDispComponent extends WordDispComponent {

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    protected cdRef: ChangeDetectorRef,
    protected option: OptionService,
    protected globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm, cdRef, option, globalEventSvc);
  }


}
